



























import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import Decimal from '@/utils/decimal';
import { WatchObjectAsJson } from '@/decorators/watch-object-as-json';

@Component
export default class SSignedAmountInput extends Vue {
  @Prop({ type: Object, required: true }) private value!: Decimal | null;
  @Prop({ type: Boolean, default: true }) private isPositive!: boolean;
  @Prop({ type: Boolean, default: true }) private showSign!: boolean;
  @Prop(Boolean) private immediate!: boolean;

  private internalValue: Decimal | null = null;

  private created(): void {
    if (this.immediate) {
      this.setvalue();
    }
  }

  private get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  @WatchObjectAsJson('value', { immediate: true })
  private setInternalValue(): void {
    this.internalValue = this.value?.abs() || new Decimal(0);
  }

  @Watch('internalValue')
  @Watch('isPositive')
  @Emit('input')
  private setvalue(): Decimal {
    return this.internalValue!.mul(this.isPositive ? 1 : -1);
  }
}
